<template>
    <div class="answer-item__con align-stretch">
        <div class="answer-item__textarea">
            <v-textarea v-model="content" outlined />
        </div>
        <div class="answer-item__btn-wrap">
            <v-btn block color="primary" height="100%" @click="save">등록</v-btn>
        </div>
    </div>
</template>

<script>
import api from "@/api";
export default {
    props: ["value", "response"],
    data() {
        return {
            content: null,
        };
    },
    methods: {
        async save() {
            try {
                const {
                    response: { _id: _response },
                    content,
                    value,
                } = this;
                const { counselComment } = await api.v1.counsels.comments.post({
                    _response,
                    content,
                });

                const responses = [...value.responses];
                const target = responses.find(({ _id }) => _id == _response);
                const comments = [...(target.comments || []), counselComment];
                Object.assignDefined(target, { comments });
                this.$emit("input", { ...value, responses });
                this.$emit("close");

                alert("등록되었습니다.");
            } catch (error) {
                this.$handleError(error);
            }
        },
    },
};
</script>

<style></style>
